import { render, staticRenderFns } from "./PaymentNotification.vue?vue&type=template&id=bf264298"
import script from "./PaymentNotification.vue?vue&type=script&lang=js"
export * from "./PaymentNotification.vue?vue&type=script&lang=js"
import style0 from "./PaymentNotification.vue?vue&type=style&index=0&id=bf264298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports